import { GetPendingOrdersState } from './getPendingOrders.types'

export const getPendingOrdersInitialState: GetPendingOrdersState = {
  loading: false,
  error: null,
  success: null
}

export default getPendingOrdersInitialState
